import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import {
	IAppWillMountHandler,
	FeatureExportsSymbol,
	ReducedMotionSymbol,
	ViewerModelSym,
	ViewerModel,
	Experiments,
	ExperimentsSymbol,
	SiteFeatureConfigSymbol,
	ServicesManagerSymbol,
} from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import type { ServicesManager } from '@wix/services-manager/types'
import { EnvironmentDefinition } from '@wix/viewer-service-environment'
import { name } from './symbols'
import { EnvSiteConfig } from './types'

const exportsName = 'env'

export const EnvFactory = withDependencies(
	[
		named(FeatureExportsSymbol, name),
		ReducedMotionSymbol,
		ViewerModelSym,
		ExperimentsSymbol,
		named(SiteFeatureConfigSymbol, name),
		optional(ServicesManagerSymbol),
	],
	(
		envExports: IFeatureExportsStore<typeof exportsName>,
		reducedMotion: boolean,
		viewerModel: ViewerModel,
		experiments: Experiments,
		siteFeatureConfig: EnvSiteConfig,
		servicesManager?: ServicesManager
	): IAppWillMountHandler => {
		let editorType: string
		let domain: string
		let previewMode: boolean
		let userId: string
		let exportedExperiments: Experiments

		if (experiments['specs.thunderbolt.servicesInfra'] && experiments['specs.thunderbolt.megaService']) {
			const envService = servicesManager?.getService(EnvironmentDefinition)
			if (envService) {
				;({ editorType, domain, previewMode, userId, experiments: exportedExperiments } = envService)
			}
		} else {
			;({ editorType, domain, previewMode } = siteFeatureConfig)
			userId = viewerModel.site.userId
			exportedExperiments = experiments
		}

		return {
			appWillMount() {
				envExports.export({
					reducedMotion,
					editorType,
					userId,
					domain,
					previewMode,
					experiments: exportedExperiments,
				})
			},
		}
	}
)
